import o from "./ghl-ui.es828.js";
import t from "./ghl-ui.es829.js";
import a from "./ghl-ui.es830.js";
import r from "./ghl-ui.es831.js";
import e from "./ghl-ui.es832.js";
var m = {
  code: "es",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const n = m;
export {
  n as default
};
